import type { SVGProps } from 'react';

export const WriteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.11426 12.6664C5.66631 12.6665 6.11408 13.1143 6.11426 13.6664C6.11426 14.2185 5.66641 14.6662 5.11426 14.6664H4.33301C3.78154 14.6665 3.33318 15.1149 3.33301 15.6664C3.33301 16.218 3.78144 16.6662 4.33301 16.6664H19.667C21.323 16.6665 22.6668 18.0103 22.667 19.6664C22.667 21.3225 21.3231 22.6662 19.667 22.6664H17C16.4477 22.6664 16 22.2186 16 21.6664C16.0002 21.1142 16.4478 20.6664 17 20.6664H19.667C20.2186 20.6662 20.667 20.218 20.667 19.6664C20.6668 19.1149 20.2185 18.6665 19.667 18.6664H4.33301C2.67688 18.6662 1.33301 17.3225 1.33301 15.6664C1.33318 14.0103 2.67698 12.6665 4.33301 12.6664H5.11426ZM16.4082 2.17709C17.4962 1.08938 19.3973 1.08801 20.4893 2.17709C21.6133 3.30243 21.6133 5.13379 20.4893 6.25912L13.4893 13.2591C12.3065 14.4415 9.63422 14.5441 9.11426 14.5521C8.85056 14.552 8.59607 14.4468 8.4082 14.2591C8.21631 14.0686 8.11039 13.807 8.11426 13.5365C8.12359 13.0165 8.22562 10.3604 9.4082 9.17905L16.4082 2.17709Z"
      fill="currentColor"
    />
  </svg>
);
